import Image from 'next/image';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { useRouter } from 'next/router'
import Twitter from '@/public/icons/x.svg';
import Linkedln from '@/public/icons/ln.svg';
import Facebook from '@/public/icons/fb.svg';

const SocialShare = ({flex}: {flex: string}) => {
  const { asPath } = useRouter()
  const shareUrl = `https://www.consulteer.com${  asPath}`;
  // LinkedinShareButton will work when we goes online, because Linkedin Crawlers don't find url online and we gets errors.
  return (
    <div className={`SocialShare flex ${flex}`}>
      <TwitterShareButton
        url={shareUrl}
      >
        <Image src={Twitter} alt="Twitter" width={25} height={25} className={`${flex === 'flex-col' ? 'mb-5' : 'mr-5'}`} />
      </TwitterShareButton>
      <LinkedinShareButton
        url={shareUrl}
        title="naslov"
      >
        <Image src={Linkedln} alt="Linkedln" width={25} height={25} className={`${flex === 'flex-col' ? 'mb-5' : 'mr-5'}`} />
      </LinkedinShareButton>
      <FacebookShareButton
        url={shareUrl}
      >
        <Image src={Facebook} alt="Facebook" width={25} height={25} className={`${flex === 'flex-col' ? 'mb-5' : 'mr-5'}`} />
      </FacebookShareButton>
    </div>
  );
};

export default SocialShare;
